import { html, css } from 'lit';
import { NexusComponent } from '../modules/nexus.component';

export class SpinnerComponent extends NexusComponent {
    static properties = {
        size: { type: Number },
        text: { type: String },
    };

    static get styles() {
        return css`
            :host {
                display: inline-flex;
                align-items: center;
                gap: 8px;
                color: currentColor;
            }
            .ring {
                width: var(--spinner-size, 18px);
                height: var(--spinner-size, 18px);
                border: 2px solid rgba(0,0,0,0.15);
                border-top-color: currentColor;
                border-radius: 50%;
                animation: spin 0.8s linear infinite;
                flex: 0 0 auto;
            }
            .label { font-size: 0.9em; opacity: 0.8; }
            @keyframes spin { to { transform: rotate(360deg); } }
        `;
    }

    constructor() {
        super();
        this.size = 18;
        this.text = '';
    }

    render() {
        const sizePx = `${this.size}px`;
        return html`
            <span class="ring" style=${`--spinner-size:${sizePx}`}></span>
            ${this.text ? html`<span class="label">${this.text}</span>` : html``}
        `;
    }
}

// Register custom element (kebab-case required for web components)
window.customElements.define('spinner-component', SpinnerComponent);

